import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'

import { assessmentsApi } from '../../_augmentt/services/assessments'
import { customerCollectionsApi } from '../../_augmentt/services/customerCollections'
import { featureFlagsApi } from '../../_augmentt/services/featureFlags'
import { hubApi } from '../../_augmentt/services/hub'
import { intuneAppPoliciesApi } from '../../_augmentt/services/intuneAppPolicies'
import { intuneMobileAppConfigurationsApi } from '../../_augmentt/services/intuneMobileAppConfigurations'
import { intuneMobileAppsApi } from '../../_augmentt/services/intuneMobileApps'
import { secureApi } from '../../_augmentt/services/secure'
import { rootReducer } from './rootDuck'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // These should be enabled and reported issues fixed
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      featureFlagsApi.middleware,
      secureApi.middleware,
      assessmentsApi.middleware,
      customerCollectionsApi.middleware,
      intuneAppPoliciesApi.middleware,
      intuneMobileAppConfigurationsApi.middleware,
      intuneMobileAppsApi.middleware,
      hubApi.middleware,
    ),
})

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store)

export default store
